import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCompare(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M10 20H5c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 18V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4h5V3c0-.283.096-.52.287-.712A.968.968 0 0 1 11 2c.283 0 .52.096.713.288.191.191.287.429.287.712v18c0 .283-.096.52-.287.712A.968.968 0 0 1 11 22a.968.968 0 0 1-.713-.288A.968.968 0 0 1 10 21v-1Zm-5-3h5v-6l-5 6Zm9 3v-9l5 6V6h-5V4h5c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 20h-5Z"
      />
    </BaseIcon>
  );
}
